// extracted by mini-css-extract-plugin
export default {"container":"developer_container__Gwm0b","linksWrapper":"developer_linksWrapper__xjusg","linkWrapper":"developer_linkWrapper__uwqSc"};